<section
	class="sig-component relative"
	[class.st-touched]="valueInput"
	[class.st-error]="hasError"
	(mouseenter)="mouseenter()"
	(mouseleave)="mouseleave()"
>
	@for (
		item of singleDataList | filterDeleted: enableLogicalDeletion;
		track item;
		let x = $index;
		let last = $last
	) {
		<main class="sig-main" [class.shake-horizontal]="item.confirmDelete">
			@if (!isDisabled && (singleDataList | filterDeleted: enableLogicalDeletion).length > 1) {
				<span (click)="removeFromArray($event, item)">
					<lbca-icon name="ic:baseline-delete-outline" [size]="24" class="hover:cursor-pointer" />
				</span>
			}
			<div class="w-full flex flex-wrap">
				<!-- <div class="sig-trash-container" [ngStyle]="singleDataList.length === 1?{ 'visibility': 'hidden' }

        : { 'visibility': 'visible' } ">
        <span class="sig-trash" (click)="removeFromArray($event, item)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.125 8.5H15.5V7.625C15.4992 6.92904 15.2224 6.26181 14.7303 5.76969C14.2382 5.27757 13.571 5.00076 12.875 5H11.125C10.429 5.00076 9.76181 5.27757 9.26969 5.76969C8.77757 6.26181 8.50076 6.92904 8.5 7.625V8.5H5.875C5.64294 8.5 5.42038 8.59219 5.25628 8.75628C5.09219 8.92038 5 9.14294 5 9.375C5 9.60706 5.09219 9.82962 5.25628 9.99372C5.42038 10.1578 5.64294 10.25 5.875 10.25H6.75V18.125C6.75 18.3571 6.84219 18.5796 7.00628 18.7437C7.17038 18.9078 7.39294 19 7.625 19H16.375C16.6071 19 16.8296 18.9078 16.9937 18.7437C17.1578 18.5796 17.25 18.3571 17.25 18.125V10.25H18.125C18.3571 10.25 18.5796 10.1578 18.7437 9.99372C18.9078 9.82962 19 9.60706 19 9.375C19 9.14294 18.9078 8.92038 18.7437 8.75628C18.5796 8.59219 18.3571 8.5 18.125 8.5ZM10.25 7.625C10.2503 7.39303 10.3426 7.17064 10.5066 7.00661C10.6706 6.84258 10.893 6.7503 11.125 6.75H12.875C13.107 6.7503 13.3294 6.84258 13.4934 7.00661C13.6574 7.17064 13.7497 7.39303 13.75 7.625V8.5H10.25V7.625ZM15.5 17.25H8.5V10.25H15.5V17.25Z"
              fill="#949494" />
            </svg>
          </span>
        </div> -->
				<!--
        <section *ngIf="!isDisabled && isLabeled" class="sig-trash-container"
          [class.opacity-0]="(!item.remove )" [ngStyle]="singleDataList.length === 1?{ 'visibility': 'hidden' }
        : { 'visibility': 'visible' } ">
          <span class="sig-trash" (click)="removeFromArray($event, item)"></span>
        </section> -->
				@for (field of item.config; track field; let i = $index) {
					<!-- !item.remove mal funcionamento -->
					@if (field.type === 'MONETARY_SEMI_FORM') {
						<legalboxplus-monetary-semi-form
							class="w-full"
							[value]="item"
							(focusState)="focusState($event, item)"
							(changeValue)="changeFieldSemiForm($event, item.index)"
						></legalboxplus-monetary-semi-form>
					}
					<div class="sig-main-div" [ngClass]="'ttfc-field-size-' + field.size">
						<!-- <div class="sig-input-view-container  ml-[10px]"    [class.ml-[0px]]="!item.remove && i === 0"
            [class.ml-[40px]]="item.remove && i === 0" [class.sig-container]="isLabeled" *ngIf="field.type === 'TEXT'"> -->
						@if (field.type === 'TEXT') {
							<div
								class="sig-input-view-container mr-[10px]"
								[class.ml-[40px]]="item.remove && singleDataList.length > 1"
								[class.ml-[0px]]="!item.remove"
								[class.sig-container]="isLabeled"
							>
								<!--   [disabled]="!(!item.canEdit &&  field.disabled) || field.disabled"  -->
								<lbca-input-text
									#inputData
									[ngClass]="'ttfc-field-size-' + field.size"
									[label]="field.label"
									[labeled]="isLabeled"
									[value]="item[field.entityKey]"
									[maskInput]="field.mask"
									[disabled]="field.disabled"
									[remove]="
										item.canEdit &&
										!itensToExclude.includes(fieldConfiguration.primary[0]?.entityKey) &&
										singleDataList.length > 1
											? item.canEdit
											: false
									"
									(removeAction)="confirmDeleteItem($event, item)"
									(focusState)="focusState($event, item)"
									(setError)="setErrorState($event, field.entityKey)"
									(validStatus)="setValidState($event, field.entityKey)"
									(changeValue)="changeField($event, field, item.index)"
								></lbca-input-text>
							</div>
						}
						@if (field.type === 'SELECT_ONE') {
							<div
								class="sig-input-view-container mr-[10px]"
								[class.ml-[0px]]="!item.remove && i === 0"
								[class.ml-[40px]]="item.remove && i === 0"
								[class.sig-container]="isLabeled"
							>
								<lbca-entity-fields
									[ngClass]="'ttfc-field-size-' + field.size"
									[forceType]="'SELECT_ONE'"
									[field]="field"
									[label]="field.label"
									[labeled]="isLabeled"
									[value]="item[field.entityKey]"
									[cardData]="cardInfo"
									[disabled]="!item.canEdit || field.disabled"
									(removeAction)="confirmDeleteItem($event, item)"
									(focusState)="focusState($event, item)"
									(errorState)="setErrorState($event, field.entityKey)"
									(validStatus)="setValidState($event, field.entityKey)"
									(changeValue)="changeField($event, field, item.index)"
								></lbca-entity-fields>
							</div>
						}
						@if (field.type === 'CALENDAR') {
							<div
								class="sig-input-view-container mr-[10px]"
								[class.ml-[0px]]="!item.remove && i === 0"
								[class.ml-[40px]]="item.remove && i === 0"
								[class.sig-container]="isLabeled"
							>
								<lbca-date-picker
									[labeled]="true"
									[ngClass]="'ttfc-field-size-' + field.size"
									[label]="field.label"
									[require]="field.required"
									[disabled]="!item.canEdit || field.disabled"
									[value]="field.value"
									[rules]="field.rules"
									[disabledDateRules]="field.disabledDateRules"
									(errorState)="setErrorState($event, field.entityKey)"
									(validStatus)="setValidState($event, field.entityKey)"
									(changeValue)="changeField($event, field, item.index)"
								></lbca-date-picker>
							</div>
						}
						@if (field.type === 'INPUT_REF') {
							<div
								class="sig-input-view-container mr-[10px]"
								[class.ml-[0px]]="!item.remove && i === 0"
								[class.ml-[40px]]="item.remove && i === 0"
								[class.sig-container]="isLabeled"
							>
								<legalboxplus-input-reference
									[cardData]="cardInfo"
									[field]="field"
									[value]="field.value"
									[label]="field.label"
								></legalboxplus-input-reference>
							</div>
						}

						@if (field.type === 'FILE_FROM_PROCESS') {
							<lbca-file-from-process
								[label]="field.label"
								[buttonLabel]="field.buttonLabel"
								[value]="data ? data[field.entityKey] : ''"
								[context]="field.context"
								[cardData]="cardInfo"
								[properties]="field"
								(saveValue)="saveUpload($event)"
							></lbca-file-from-process>
						}
					</div>
				}
				<!-- <section *ngIf="!isDisabled && isLabeled" class="sig-confirm-remove-external"
        [ngStyle]="item.canEdit &&  (itensToExclude.includes(fieldConfiguration.primary[0]?.entityKey)) && (singleDataList.length > 1 )  ?{ 'visibility': 'visible' }
      : { 'visibility': 'hidden' } ">
        <span class="sig-trash-confirm" (click)="confirmDeleteItem($event, item)"></span>
      </section> -->
			</div>
		</main>
		@if (isLabeled && last) {
			<footer class="sig-form-add">
				<div class="sig-form-col">
					<div class="sig-form-add-container" (click)="newField()">
						<span class="sig-form-add">
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M5 5V0.666667C5.11111 0.444444 5.33333 0 6 0C6.66667 0 6.88889 0.444444 7 0.666667V5H11.3333C11.5556 5.11111 12 5.46667 12 6C12 6.53333 11.5556 6.88889 11.3333 7H7V11.3333C7 11.3333 6.66667 12 6 12C5.33333 12 5 11.3333 5 11.3333V7H0.666667C0.666667 7 0 6.66667 0 6C0 5.33333 0.666667 5 0.666667 5H5Z"
								/>
							</svg>
						</span>
						<span class="sig-form-add-txt">
							Acrescentar
							{{ fieldConfiguration.primary[1]?.label || fieldConfiguration.primary[0].label }}
						</span>
					</div>
				</div>
			</footer>
		}
		@if (singleDataList.length > 1) {
			<div class="divider"></div>
		}
	}
</section>
<ng-template #templateRemove>
	<div class="text-base text-font flex items-center justify-center show gap-2">
		{{ fieldConfiguration.primary[1]?.label || fieldConfiguration.primary[0].label }} excluído!
		<lbca-icon name="emoji--wastebasket" [size]="24" />
	</div>
</ng-template>
<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<lbca-icon name="emoji--happy" [size]="24" />
	</div>
</ng-template>
